import { MutedSkeleton } from '~/common/skeletons'
import { DetailContent, DetailHeader, DetailHeading } from './Detail'

export function DetailSkeleton() {
  return (
    <>
      <DetailHeader>
        <MutedSkeleton w="200px">
          <DetailHeading>...</DetailHeading>
        </MutedSkeleton>
      </DetailHeader>
      <DetailContent>
        <MutedSkeleton h="full" w="full" />
      </DetailContent>
    </>
  )
}

DetailSkeleton.displayName = 'SplitList.DetailSkeleton'
